import { createAsyncThunk } from '@reduxjs/toolkit';

import { SecondaryMarketService } from 'api';

export const getCounterofferProperties = createAsyncThunk(
	'secondaryMarket/getCounterofferProperties',
	async (id: string) => {
		return await SecondaryMarketService.getCounterofferProperties(id);
	},
);
